/* eslint-disable typescript-extended-rules/file-naming-convention */
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { BeneficiaryReconciliationApplyAction } from '../../../../../modules/beneficiary-reconciliations/models/beneficiary-reconciliation.model';

interface ApplyPreviewSummary {
	action: BeneficiaryReconciliationApplyAction;
	count: number;
	label: string;
}

interface ApplyPreviewDialogData {
	autoSuggestedCount: number;
	manualReviewedCount: number;
	summaries: ApplyPreviewSummary[];
	total: number;
}

@Component({
	selector: 'app-beneficiary-reconciliation-apply-preview-modal',
	styleUrls: [
		'./beneficiary-reconciliation-apply-preview-modal.component.scss',
	],
	templateUrl:
		'./beneficiary-reconciliation-apply-preview-modal.component.html',
})
export class BeneficiaryReconciliationApplyPreviewModalComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: ApplyPreviewDialogData,
		private readonly dialogRef: MatDialogRef<BeneficiaryReconciliationApplyPreviewModalComponent>,
	) {}

	onCancel(): void {
		this.dialogRef.close(false);
	}

	onConfirm(): void {
		this.dialogRef.close(true);
	}

	trackByAction(index: number, summary: ApplyPreviewSummary): string {
		return `${summary.action}:${summary.label}`;
	}
}
